module.exports = __webpack_public_path__ + "img/arrow-down-blue.817cf27a.svg";